import { APP_INITIALIZER, ErrorHandler, Provider } from '@angular/core';
import { Router } from '@angular/router';
import { App, AppLaunchUrl, URLOpenListenerEvent } from '@capacitor/app';
import { AppConfigService } from './app-config/app-config.service';



export const AppInitializer: Provider = {
  provide: APP_INITIALIZER,
  multi: true,
  deps: [AppConfigService, ErrorHandler, Router],
  useFactory: (config: AppConfigService, handler: ErrorHandler, router: Router) => async () => {
    const handleLaunchUrl = (data: URLOpenListenerEvent | AppLaunchUrl) => {
      const url = data.url;
        const CUSTOM_SCHEME = 'versapos://';
        if (url.startsWith(CUSTOM_SCHEME)) {
          const navigationUrl = url.replace(CUSTOM_SCHEME, '/');
          config.initConfigFromUrl(navigationUrl);
        }
    };

    try {
      App.addListener('appUrlOpen', data => {
        handleLaunchUrl(data);
        // Note: we must reload the whole application to properly initialize every app-config dependent services
        router.navigateByUrl('/').then(() => window.location.reload());
      });
      config.initConfig();
    } catch (e) {
      // Manually catching error because angular can't navigate if the error happens in providers
      // https://github.com/angular/angular/issues/25589
      setTimeout(() => handler.handleError(e), 0);
    }
  }
};
